import { Navigate } from 'react-router-dom'
import { useAuth } from '@/lib/auth'
import { homePath } from '@/lib/rbac'

/** `/` → `/app` (ou portal) se autenticado; senão `/login`. */
export function RootRedirect() {
  const { loading, isAuthenticated, perfil } = useAuth()

  if (loading) {
    return <div className="hi-shell-loading">Carregando…</div>
  }

  if (isAuthenticated) {
    return <Navigate to={homePath(perfil)} replace />
  }

  return <Navigate to="/login" replace />
}
